<template>
    <section class="section">
        <div class="container">
            <div class="columns is-centered" style="margin: 0;">
                <div class="box column is-one-third">
                    <div class="content">
                        <h2>Password Reset</h2>
                    </div>
                    <form v-on:submit.prevent>
                        <b-field label="Your email address">
                            <b-input v-model.trim="email" @keyup.native.enter="resetPassword" type="text" placeholder="Email"></b-input>
                        </b-field>
                        <b-field class="reset-button">
                            <b-button type="submit" @click="resetPassword" :loading="isLoading" class="button is-primary">Reset password</b-button>
                        </b-field>
                        <b-message v-if="sendStatus" type="is-success" has-icon>
                            Instructions sent to your email. Redirecting to login screen in 3 seconds. See you!
                        </b-message>
                        <b-message v-else>
                            Password reset instructions are sent if your email matches that of a registered user.
                        </b-message>   
                        <hr>
                        <b-field class="login-link">
                            <router-link to="/login">
                                <p>Go back to login.</p>
                            </router-link>
                        </b-field>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import * as firebase from "../../firebase"

export default {
    data: function() {
        return {
            email: "",
            sendStatus: false,
            isLoading: false
        }
    },
    components: {
    },
    methods: {
        resetPassword: async function() {
            this.isLoading = true;
            await firebase.auth.sendPasswordResetEmail(this.email).then(() => {
                this.sendStatus = true; 
                this.email = "";
                this.isLoading = false;
                window.setTimeout(() => {
                    this.$router.push("/login");
                }, 3000)
            }).catch((error) => {
                this.$buefy.snackbar.open({type: "is-danger", message: error.message});
                this.isLoading = false;
            });
        }
    } 
}
</script>

<style scoped>
.box {
    margin-top: 10vh;
    margin-left: 2%;
    margin-right: 2%;
    margin-bottom: 10vh;
    padding: 40px;
}
.reset-button {
    margin-top: 3%;
}
</style>